/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const analyseAbstract = /* GraphQL */ `
  mutation AnalyseAbstract($input: AnalysisInput!) {
    analyseAbstract(input: $input) {
      structureScore
      sectionBreakdown
      titleAlignment
      vaguenessFlags
      suggestions
      classificationResults
      __typename
    }
  }
`;
export const createAccounts = /* GraphQL */ `
  mutation CreateAccounts(
    $input: CreateAccountsInput!
    $condition: ModelAccountsConditionInput
  ) {
    createAccounts(input: $input, condition: $condition) {
      id
      name
      abbreviation
      APIkey
      contacts
      token
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateAccounts = /* GraphQL */ `
  mutation UpdateAccounts(
    $input: UpdateAccountsInput!
    $condition: ModelAccountsConditionInput
  ) {
    updateAccounts(input: $input, condition: $condition) {
      id
      name
      abbreviation
      APIkey
      contacts
      token
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteAccounts = /* GraphQL */ `
  mutation DeleteAccounts(
    $input: DeleteAccountsInput!
    $condition: ModelAccountsConditionInput
  ) {
    deleteAccounts(input: $input, condition: $condition) {
      id
      name
      abbreviation
      APIkey
      contacts
      token
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createProjects = /* GraphQL */ `
  mutation CreateProjects(
    $input: CreateProjectsInput!
    $condition: ModelProjectsConditionInput
  ) {
    createProjects(input: $input, condition: $condition) {
      id
      token
      accountToken
      name
      abbreviation
      code
      meta
      prompts
      OZ
      config
      theme
      contacts
      timetable
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteProjects = /* GraphQL */ `
  mutation DeleteProjects(
    $input: DeleteProjectsInput!
    $condition: ModelProjectsConditionInput
  ) {
    deleteProjects(input: $input, condition: $condition) {
      id
      token
      accountToken
      name
      abbreviation
      code
      meta
      prompts
      OZ
      config
      theme
      contacts
      timetable
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createAssets = /* GraphQL */ `
  mutation CreateAssets(
    $input: CreateAssetsInput!
    $condition: ModelAssetsConditionInput
  ) {
    createAssets(input: $input, condition: $condition) {
      id
      accountToken
      projectToken
      formToken
      key
      userId
      name
      description
      type
      language
      s3Key
      fileType
      fileSize
      uploadedAt
      uploadedBy
      contentHash
      version
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateAssets = /* GraphQL */ `
  mutation UpdateAssets(
    $input: UpdateAssetsInput!
    $condition: ModelAssetsConditionInput
  ) {
    updateAssets(input: $input, condition: $condition) {
      id
      accountToken
      projectToken
      formToken
      key
      userId
      name
      description
      type
      language
      s3Key
      fileType
      fileSize
      uploadedAt
      uploadedBy
      contentHash
      version
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteAssets = /* GraphQL */ `
  mutation DeleteAssets(
    $input: DeleteAssetsInput!
    $condition: ModelAssetsConditionInput
  ) {
    deleteAssets(input: $input, condition: $condition) {
      id
      accountToken
      projectToken
      formToken
      key
      userId
      name
      description
      type
      language
      s3Key
      fileType
      fileSize
      uploadedAt
      uploadedBy
      contentHash
      version
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteSubmissions = /* GraphQL */ `
  mutation DeleteSubmissions(
    $input: DeleteSubmissionsInput!
    $condition: ModelSubmissionsConditionInput
  ) {
    deleteSubmissions(input: $input, condition: $condition) {
      id
      hidden
      formToken
      projectToken
      userId
      data
      files {
        id
        dataKey
        fileKey
        hash
        size
        uploaded
        name
        __typename
      }
      meta {
        page
        submissionLanguage
        owner
        creator
        percentComplete
        complete
        submittedAt
        invalidatedAfterSubmitAt
        trackingNumber
        AIAssigned
        __typename
      }
      linkedData {
        name
        fileType
        template
        modelType
        linkedTo
        key
        location
        createdAt
        __typename
      }
      reviews
      analysis
      token
      checked
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createForms = /* GraphQL */ `
  mutation CreateForms(
    $input: CreateFormsInput!
    $condition: ModelFormsConditionInput
  ) {
    createForms(input: $input, condition: $condition) {
      id
      token
      projectToken
      name
      type
      meta
      pages {
        title
        footer
        header
        __typename
      }
      trackingCounter
      dictionaries {
        type
        phrases
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateForms = /* GraphQL */ `
  mutation UpdateForms(
    $input: UpdateFormsInput!
    $condition: ModelFormsConditionInput
  ) {
    updateForms(input: $input, condition: $condition) {
      id
      token
      projectToken
      name
      type
      meta
      pages {
        title
        footer
        header
        __typename
      }
      trackingCounter
      dictionaries {
        type
        phrases
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteForms = /* GraphQL */ `
  mutation DeleteForms(
    $input: DeleteFormsInput!
    $condition: ModelFormsConditionInput
  ) {
    deleteForms(input: $input, condition: $condition) {
      id
      token
      projectToken
      name
      type
      meta
      pages {
        title
        footer
        header
        __typename
      }
      trackingCounter
      dictionaries {
        type
        phrases
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteUsers = /* GraphQL */ `
  mutation DeleteUsers(
    $input: DeleteUsersInput!
    $condition: ModelUsersConditionInput
  ) {
    deleteUsers(input: $input, condition: $condition) {
      id
      email
      givenName
      familyName
      language
      currentState
      forms {
        formToken
        currentPage
        editors
        __typename
      }
      projectAdmin
      createdAt
      lastLogin
      lastActivity
      dawnSnapshot
      meta
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteTokens = /* GraphQL */ `
  mutation DeleteTokens(
    $input: DeleteTokensInput!
    $condition: ModelTokensConditionInput
  ) {
    deleteTokens(input: $input, condition: $condition) {
      id
      type
      token
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteCounters = /* GraphQL */ `
  mutation DeleteCounters(
    $input: DeleteCountersInput!
    $condition: ModelCountersConditionInput
  ) {
    deleteCounters(input: $input, condition: $condition) {
      currentValue
      currentToken
      id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateEvents = /* GraphQL */ `
  mutation UpdateEvents(
    $input: UpdateEventsInput!
    $condition: ModelEventsConditionInput
  ) {
    updateEvents(input: $input, condition: $condition) {
      id
      event
      sourceId
      sourceType
      projectToken
      payload
      createdAt
      ttl
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const deleteEvents = /* GraphQL */ `
  mutation DeleteEvents(
    $input: DeleteEventsInput!
    $condition: ModelEventsConditionInput
  ) {
    deleteEvents(input: $input, condition: $condition) {
      id
      event
      sourceId
      sourceType
      projectToken
      payload
      createdAt
      ttl
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const updateLogs = /* GraphQL */ `
  mutation UpdateLogs(
    $input: UpdateLogsInput!
    $condition: ModelLogsConditionInput
  ) {
    updateLogs(input: $input, condition: $condition) {
      id
      source
      type
      projectToken
      entityId
      modelType
      description
      category
      logData
      isSuperAdmin
      isTicker
      createdAt
      ttl
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const deleteLogs = /* GraphQL */ `
  mutation DeleteLogs(
    $input: DeleteLogsInput!
    $condition: ModelLogsConditionInput
  ) {
    deleteLogs(input: $input, condition: $condition) {
      id
      source
      type
      projectToken
      entityId
      modelType
      description
      category
      logData
      isSuperAdmin
      isTicker
      createdAt
      ttl
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const updateProjects = /* GraphQL */ `
  mutation UpdateProjects(
    $input: UpdateProjectsInput!
    $condition: ModelProjectsConditionInput
  ) {
    updateProjects(input: $input, condition: $condition) {
      id
      token
      accountToken
      name
      abbreviation
      code
      meta
      prompts
      OZ
      config
      theme
      contacts
      timetable
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createSubmissions = /* GraphQL */ `
  mutation CreateSubmissions(
    $input: CreateSubmissionsInput!
    $condition: ModelSubmissionsConditionInput
  ) {
    createSubmissions(input: $input, condition: $condition) {
      id
      hidden
      formToken
      projectToken
      userId
      data
      files {
        id
        dataKey
        fileKey
        hash
        size
        uploaded
        name
        __typename
      }
      meta {
        page
        submissionLanguage
        owner
        creator
        percentComplete
        complete
        submittedAt
        invalidatedAfterSubmitAt
        trackingNumber
        AIAssigned
        __typename
      }
      linkedData {
        name
        fileType
        template
        modelType
        linkedTo
        key
        location
        createdAt
        __typename
      }
      reviews
      analysis
      token
      checked
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateSubmissions = /* GraphQL */ `
  mutation UpdateSubmissions(
    $input: UpdateSubmissionsInput!
    $condition: ModelSubmissionsConditionInput
  ) {
    updateSubmissions(input: $input, condition: $condition) {
      id
      hidden
      formToken
      projectToken
      userId
      data
      files {
        id
        dataKey
        fileKey
        hash
        size
        uploaded
        name
        __typename
      }
      meta {
        page
        submissionLanguage
        owner
        creator
        percentComplete
        complete
        submittedAt
        invalidatedAfterSubmitAt
        trackingNumber
        AIAssigned
        __typename
      }
      linkedData {
        name
        fileType
        template
        modelType
        linkedTo
        key
        location
        createdAt
        __typename
      }
      reviews
      analysis
      token
      checked
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createUsers = /* GraphQL */ `
  mutation CreateUsers(
    $input: CreateUsersInput!
    $condition: ModelUsersConditionInput
  ) {
    createUsers(input: $input, condition: $condition) {
      id
      email
      givenName
      familyName
      language
      currentState
      forms {
        formToken
        currentPage
        editors
        __typename
      }
      projectAdmin
      createdAt
      lastLogin
      lastActivity
      dawnSnapshot
      meta
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateUsers = /* GraphQL */ `
  mutation UpdateUsers(
    $input: UpdateUsersInput!
    $condition: ModelUsersConditionInput
  ) {
    updateUsers(input: $input, condition: $condition) {
      id
      email
      givenName
      familyName
      language
      currentState
      forms {
        formToken
        currentPage
        editors
        __typename
      }
      projectAdmin
      createdAt
      lastLogin
      lastActivity
      dawnSnapshot
      meta
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createTokens = /* GraphQL */ `
  mutation CreateTokens(
    $input: CreateTokensInput!
    $condition: ModelTokensConditionInput
  ) {
    createTokens(input: $input, condition: $condition) {
      id
      type
      token
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateTokens = /* GraphQL */ `
  mutation UpdateTokens(
    $input: UpdateTokensInput!
    $condition: ModelTokensConditionInput
  ) {
    updateTokens(input: $input, condition: $condition) {
      id
      type
      token
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createCounters = /* GraphQL */ `
  mutation CreateCounters(
    $input: CreateCountersInput!
    $condition: ModelCountersConditionInput
  ) {
    createCounters(input: $input, condition: $condition) {
      currentValue
      currentToken
      id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateCounters = /* GraphQL */ `
  mutation UpdateCounters(
    $input: UpdateCountersInput!
    $condition: ModelCountersConditionInput
  ) {
    updateCounters(input: $input, condition: $condition) {
      currentValue
      currentToken
      id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createEvents = /* GraphQL */ `
  mutation CreateEvents(
    $input: CreateEventsInput!
    $condition: ModelEventsConditionInput
  ) {
    createEvents(input: $input, condition: $condition) {
      id
      event
      sourceId
      sourceType
      projectToken
      payload
      createdAt
      ttl
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const createLogs = /* GraphQL */ `
  mutation CreateLogs(
    $input: CreateLogsInput!
    $condition: ModelLogsConditionInput
  ) {
    createLogs(input: $input, condition: $condition) {
      id
      source
      type
      projectToken
      entityId
      modelType
      description
      category
      logData
      isSuperAdmin
      isTicker
      createdAt
      ttl
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const incrementTrackingCounter = /* GraphQL */ `
  mutation IncrementTrackingCounter($id: ID!, $_version: Int!) {
    incrementTrackingCounter(id: $id, _version: $_version) {
      id
      token
      projectToken
      name
      type
      meta
      pages {
        title
        footer
        header
        __typename
      }
      trackingCounter
      dictionaries {
        type
        phrases
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const publishStreamChunk = /* GraphQL */ `
  mutation PublishStreamChunk(
    $submissionId: ID!
    $chunk: String!
    $done: Boolean!
    $payload: AWSJSON
  ) {
    publishStreamChunk(
      submissionId: $submissionId
      chunk: $chunk
      done: $done
      payload: $payload
    ) {
      submissionId
      chunk
      done
      payload
      __typename
    }
  }
`;
